var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.059 8.059 0 18 0s18 8.059 18 18-8.059 18-18 18S0 27.941 0 18z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18C0 8.059 8.059 0 18 0s18 8.059 18 18-8.059 18-18 18S0 27.941 0 18z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.4c-2.608 0-2.935.012-3.96.058-1.021.047-1.719.209-2.33.446a4.7 4.7 0 0 0-1.7 1.107 4.712 4.712 0 0 0-1.108 1.7c-.238.611-.4 1.31-.446 2.33-.046 1.025-.058 1.352-.058 3.96 0 2.607.012 2.933.058 3.957.047 1.022.21 1.72.446 2.33a4.704 4.704 0 0 0 1.108 1.7 4.7 4.7 0 0 0 1.7 1.109c.61.237 1.308.399 2.33.446 1.024.046 1.351.058 3.958.058 2.608 0 2.934-.012 3.958-.058 1.022-.047 1.72-.209 2.331-.446a4.697 4.697 0 0 0 1.7-1.108 4.713 4.713 0 0 0 1.107-1.7c.236-.612.398-1.31.446-2.33.046-1.025.058-1.351.058-3.959 0-2.607-.012-2.934-.058-3.958-.048-1.022-.21-1.72-.446-2.33a4.712 4.712 0 0 0-1.108-1.7 4.692 4.692 0 0 0-1.7-1.108c-.612-.237-1.31-.399-2.332-.446-1.024-.046-1.35-.058-3.958-.058H18zm-.862 1.73H18c2.564 0 2.867.01 3.88.056.936.042 1.444.199 1.782.33.448.174.767.382 1.103.718.336.336.544.656.719 1.104.131.338.288.846.33 1.782.046 1.012.056 1.316.056 3.878 0 2.562-.01 2.866-.056 3.878-.043.936-.199 1.444-.33 1.782a2.968 2.968 0 0 1-.719 1.103 2.968 2.968 0 0 1-1.103.718c-.338.132-.846.288-1.782.331-1.012.046-1.316.056-3.88.056-2.563 0-2.867-.01-3.879-.056-.936-.043-1.444-.2-1.782-.331a2.973 2.973 0 0 1-1.104-.718 2.975 2.975 0 0 1-.719-1.103c-.131-.338-.288-.847-.33-1.783-.046-1.012-.056-1.316-.056-3.88 0-2.563.01-2.865.056-3.877.042-.936.199-1.444.33-1.783.174-.448.383-.768.718-1.104a2.98 2.98 0 0 1 1.104-.718c.339-.132.847-.288 1.783-.331.886-.04 1.229-.052 3.018-.054v.002zm4.834 2.746a1.152 1.152 0 1 1 2.304 0 1.152 1.152 0 0 1-2.304 0zm-3.973.194A4.93 4.93 0 1 0 18 22.93a4.93 4.93 0 0 0 0-9.86zM21.2 18a3.2 3.2 0 1 0-6.4 0 3.2 3.2 0 0 0 6.4 0z",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.bd0b7780096009df3e244ec95ae7543a.svg";
export { ForwardRef as ReactComponent };